export default "{\n    \"emptyText\": \"Select technician\",\n    \"placeholderText\": \"Search by name\",\n    \"addNewTechnician\": \"Add New Technician\"\n}"